<template>
    <div class="product-circle">
        <!-- canvas画圆 -->
         <canvas class="canvas-view" :id="canvasId"></canvas>
    </div>
</template>
<script>
export default {
    name: 'ProductCircle',
    props: {
        color: {
            type: String,
            default: '#7879F8',
        },
        circleArrow: {
            type: String,
            default: 'bottom',
        },
        circleCenterText: {
            type: String,
            default: '01',
        },
        labelText: {
            type: String,
            default: '办公效率',   
        }
    },
    data() {
        function generateRandomLetters() {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            const charactersLength = characters.length;
            for (let i = 0; i < 3; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
        return {
            canvasId: generateRandomLetters() + new Date().getTime(),
        }
    },
    mounted() {
        this.drawCircle();
    },
    methods: {
        // 画圆
        drawCircle() {
            const canvas = document.getElementById(this.canvasId);
            const ctx = canvas.getContext('2d');
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;

            let lineWidth = 10;
            const centerX = canvas.width / 2;
            let centerY = centerX + (canvas.height - canvas.width);
            if (this.circleArrow === 'up') {
                centerY = centerX;
            }
            
            const radius = 80;
            ctx.beginPath();
            // 调整bottom模式角度为315°→225°（逆时针）
            const startAngle = this.circleArrow === 'up' ? Math.PI/4 : (7 * Math.PI)/4;  // 315度
            const endAngle = this.circleArrow === 'up' ? (3 * Math.PI)/4 : (5 * Math.PI)/4;  // 225度
            const anticlockwise = this.circleArrow === 'up';  // 始终逆时针绘制
            
            ctx.arc(
                centerX, 
                centerY, 
                radius, 
                startAngle, 
                endAngle, 
                anticlockwise
            );
            ctx.strokeStyle = this.color;
            ctx.lineWidth = lineWidth;
            ctx.stroke();
            // 新增三角形绘制逻辑
            ctx.beginPath();
            const triangleSize = 10;
            const gapCenterAngle = this.circleArrow === 'up' 
                ? Math.PI/2  // 上方缺口中心角度（90度）
                : 3*Math.PI/2; // 下方缺口中心角度（270度）
            
            // 计算三角形顶点坐标
            // 修正三角形中心点计算（移除半径偏移）
            const triangleCenterX = this.circleArrow === 'up'? - 10: 10;
            const triangleCenter = {
                x: centerX + Math.cos(gapCenterAngle) * radius,  // 直接使用圆弧半径
                y: centerY + Math.sin(gapCenterAngle) * radius + triangleCenterX   // 直接使用圆弧半径
            };
            
            // 调整三角形顶点偏移量
            const verticalOffset = triangleSize * 2;  // 加大偏移量
            
            // 绘制三角形（根据方向调整偏移）
            if(this.circleArrow === 'up') {
                ctx.moveTo(triangleCenter.x - triangleSize, triangleCenter.y);
                ctx.lineTo(triangleCenter.x + triangleSize, triangleCenter.y);
                ctx.lineTo(triangleCenter.x, triangleCenter.y + verticalOffset); 
            } else {
                ctx.moveTo(triangleCenter.x - triangleSize, triangleCenter.y);
                ctx.lineTo(triangleCenter.x + triangleSize, triangleCenter.y);
                ctx.lineTo(triangleCenter.x, triangleCenter.y - verticalOffset);
            }
            
            ctx.closePath();
            ctx.fillStyle = this.color;
            ctx.fill();

            // 新增中心文字绘制
            ctx.save(); // 保存绘图状态
            // 修改字体样式添加bold
            ctx.font = 'bold 20px Arial';  // 增加bold加粗
            ctx.textAlign = 'center'; // 水平居中
            ctx.textBaseline = 'middle'; // 垂直居中
            ctx.fillStyle = '#333'; // 使用相同颜色
            ctx.fillText(this.circleCenterText, centerX, centerY);
            ctx.restore(); // 恢复绘图状态

            ctx.save(); // 保存绘图状态
            ctx.font = 'bold 24px Arial';  // 增加bold加粗
            ctx.textAlign = 'center'; // 水平居中
            ctx.textBaseline = 'middle'; // 垂直居中
            ctx.fillStyle = '#333'; // 使用相同颜色
            ctx.fillText(this.labelText, centerX, this.circleArrow === 'up'? canvas.height - 10: 15);
            ctx.restore(); // 恢复绘图状态
        }
    }
}
</script>
<style lang="scss" scoped>
.product-circle {
    width: 182px;
    height: 226px;
    .canvas-view {
        width: 182px;
        height: 226px;
    }
}
</style>